function initUploadPhotos() {
    const form = document.querySelector('.quest-form form');
    if (!form) return;
    const progressBlock = form.querySelector('.progress-block');

    if (!progressBlock) return;
    const submitBtn = form.querySelector('input[type="submit"]');
    const progressBar = progressBlock.querySelector('#files-progress');
    const progressLabel = progressBlock.querySelector('label');
    if (!submitBtn || !progressBar || !progressLabel) return;

    function showSuccessBlock(link) {
        const successBlock = document.querySelector('.utils-upload__success');
        const successLink = document.querySelector('.utils-upload__success a');
        if (!successBlock || !successLink) return;

        successBlock.style.display = 'block';
        successLink.href = link;
    }

    form.addEventListener('submit', function(e) {
        e.preventDefault();
        progressBlock.style.display = 'grid';

        const inputFiles = form.querySelector('input[name="files[]"]');
        if (!inputFiles || inputFiles.files.length === 0) return;

        const files = Array.from(inputFiles.files);
        const totalFiles = files.length;
        let uploadedFiles = 0;
        let galleryId = null;

        function uploadChunk(chunk) {
            const formData = new FormData(form);
            formData.delete('files[]');
            chunk.forEach(file => formData.append('files[]', file));
            if (galleryId) {
                formData.append('gallery_id', galleryId);
            }

            const xhr = new XMLHttpRequest();
            xhr.responseType = 'json';
            xhr.open('POST', '/api-xpage/photo/uploadGallery/');
            xhr.upload.onprogress = function(e) {
                if (e.lengthComputable) {
                    const percentComplete = (e.loaded / e.total) * 100;
                    progressBar.value = ((uploadedFiles + percentComplete / 100 * chunk.length) / totalFiles) * 100;
                }
            };
            xhr.onload = function() {
                if (xhr.status === 200) {
                    uploadedFiles += chunk.length;
                    progressLabel.textContent = `Загружено ${uploadedFiles} фото из ${totalFiles}`;
                    if (uploadedFiles < totalFiles) {
                        if (xhr.response.data[0]) {
                            galleryId = xhr.response.data[0].split('/').at(-2);
                        }
                        uploadChunk(files.splice(0, 5));
                    } else {
                        showSuccessBlock(xhr.response.data[0] || '');
                    }
                } else {
                    alert('При загрузке произошла ошибка, попробуйте снова');
                }
            };
            xhr.send(formData);
        }

        uploadChunk(files.splice(0, 5));
    });
}